//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'rut',
        value: 'customerRut',
        format: 'rut',
    },
    {
        text: 'cliente',
        value: 'customerName',
    },
    {
        text: 'estado',
        value: 'status',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                small: true,
                palette: {
                    atrasado: 'error lighten-3',
                    pendiente: 'accent lighten-3',
                },
            },
        },
    },
    {
        text: 'n° facturas',
        value: 'invoiceCount',
        align: 'right',
    },
    {
        text: 'Prox. Pago',
        value: 'payDate',
        align: 'right',
        format: 'date',
    },
    {
        text: 'deuda total',
        value: 'total',
        align: 'right',
        classes: 'accent lighten-3 font-weight-medium',
        format: 'currency',
    },
    {
        text: 'Correos enviados',
        value: 'is_send',
        align: 'center',
        format: 'number',
    },
]
